import { render, staticRenderFns } from "./UploadIosCert.vue?vue&type=template&id=739e572c&scoped=true&"
import script from "./UploadIosCert.vue?vue&type=script&lang=js&"
export * from "./UploadIosCert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739e572c",
  null
  
)

export default component.exports